import { render, staticRenderFns } from "./PendencyPriorityDropdown.vue?vue&type=template&id=77221152"
import script from "./PendencyPriorityDropdown.vue?vue&type=script&lang=js"
export * from "./PendencyPriorityDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports